module.exports = __webpack_public_path__ + "static/media/titlePanoramicDoorhan.e2c44b3c.jpg";